// extracted by mini-css-extract-plugin
export default {"col":"ActionsContainer_col__BTR4H"};